import { collectionReducer } from 'utils/reducerGenerator';

import followUpRecord from 'records/followUp';

export const { reducer, types } = collectionReducer({
    namespace: 'FOLLOW_UP',
    transformer: followUpRecord,
});

export default reducer;
